import AppStateEnum from '@/enums/AppStateEnum';

import AppConstantsUtil from '@/services/utils/AppConstantsUtil';

export default {
  methods: {
    $_getHtmlElement() {
      return document.querySelector('html');
    },
    addGuestClass() {
      const html = this.$_getHtmlElement();
      html.classList.add(AppConstantsUtil.GUEST_AREA_CLASS);
    },
    removeGuestClass() {
      const html = this.$_getHtmlElement();
      html.classList.remove(AppConstantsUtil.GUEST_AREA_CLASS);
    },
    initZoom() {
      this.$store.dispatch('ZoomStore/init');
    },
    initOpenedPublication() {
      const publicationType = this.$store.getters[
        'OpenParameterStore/getPublicationType'
      ];
      if (!this.$_shouldInitPublication() || !publicationType) {
        return;
      }

      return this.$store.dispatch('LibraryStore/initStateByPublicationTypes', {
        publicationsTypes: [publicationType],
        forceRemote: false
      });
    },
    $_shouldInitPublication() {
      return this.$route.name === AppStateEnum.PRESENT_PUBLICATION;
    },
    initLibraryState(states = []) {
      if (!this.$_shouldInitLibraryState() || !states.length) {
        return;
      }
      const promises = states.map(state =>
        this.$store.dispatch('LibraryStore/initState', {
          managePublicationsState: state,
          forceRemote: false
        })
      );
      return Promise.all(promises);
    },
    $_shouldInitLibraryState() {
      const appState = this.$store.getters['ContextStore/appState'];
      return [
        AppStateEnum.MANAGE_PUBLICATION,
        AppStateEnum.PRESENT_PUBLICATION,
        AppStateEnum.DEVELOP_LIBRARY_SET,
        AppStateEnum.STUDY_CLASS
      ].includes(appState);
    }
  }
};
